const freeThemes = ["default", "light", "dark", "grey", "blue", "red", "professional", "social"];
export default freeThemes;
